import './PostCard.css';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { FiArrowUpRight } from "react-icons/fi";
import { Link } from 'react-router-dom';
import useContentful from '../../../hooks/useContentfull';
import { useEffect } from 'react';
import { Avatar } from '@mui/material';
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";

const PostCard = ({ post }) => {

    return (
        <div className="blog-card">
            {/* Header Image */}
            <div className="blog-card-image">
                <img src={post.headerImage} alt={post.title} />
            </div>

            {/* Content */}
            <div className="blog-card-content">
                <div className="blog-card-date-container">
                    <span className="blog-card-date">
                        Published in {new Date(post.publicationDate).toLocaleDateString()}
                    </span>
                </div>

                <div className="blog-card-author">
                    {
                        post.author.profilePicture ?
                            <img src={post.author.profilePicture} alt={post.author.name} className="blog-card-author-image" />
                            :
                            <Avatar sx={{ width: 32, height: 32 }}>{post.author.name.charAt(0)}</Avatar>
                    }
                    <span className="blog-card-author-name">{post.author.name}</span>
                </div>

                <div className="blog-card-text">
                    <h2 className="blog-card-title">{post.title}</h2>

                    <div className="blog-card-body">
                        {post.body && documentToPlainTextString(post.body)}
                    </div>

                </div>

                <Link to={`/blog/${post.slug}`}>
                    <button className="btn-icon-primary">
                        Read More
                        <FiArrowUpRight className='icon' />
                    </button>
                </Link>

            </div>
        </div>
    );
};

export default PostCard;